module.exports = __webpack_public_path__ + "img/ls-logo.d7934164.png";